import { useState, useEffect } from "react";
import { fetchProfileCached } from "../utils/cacheService";
import { useTranslation } from 'react-i18next';
import FeedHeader from "../components/FeedComponents/FeedHeader";
import StoriesBar from "../components/FeedComponents/StoriesBar";
import FeedPost from "../components/FeedComponents/FeedPost";
import BottomNav from "../components/FeedComponents/BottomNav";
import TrialBanner from "../components/TrialComponents/TrialBanner";
import "./Feed.css";

import avChat2 from "../assets/feed/chat2.png";
import avChat1 from "../assets/feed/chat1.png";
import avChat3 from "../assets/feed/avatarcariani.jpg";
import av1 from "../assets/feed/av-fallback-1.jpg";
import av2 from "../assets/feed/av-fallback-2.jpg";
import av3 from "../assets/feed/av-fallback-3.jpg";
import av4 from "../assets/feed/av-fallback-4.jpg";
import av5 from "../assets/feed/av-fallback-5.jpg";
import av6 from "../assets/feed/av-fallback-6.jpg";
import av7 from "../assets/feed/av-fallback-7.jpg";
import av8 from "../assets/feed/av-fallback-8.jpg";
import av9 from "../assets/feed/av-fallback-9.jpg";
import av10 from "../assets/feed/av-fallback-10.jpg";
import av11 from "../assets/feed/av-fallback-11.jpg";
import av12 from "../assets/feed/av-fallback-12.jpg";
import avatarNicolas from "../assets/feed/avatarnicolas.jpg";
import postagemNicolas from "../assets/feed/postagemnicolas.jpg";
import postagemCariani from "../assets/feed/postcariani.jpg";

const MOCK_POSTS = [
  { username: "An*****", avatar: avChat2, postImage: av5, likes: 204, comments: 8, time: "26 de janeiro de 2025", description: "Mais um dia incrível 🌅✨" },
  { username: "Ni*****", avatar: avatarNicolas, postImage: postagemNicolas, likes: 1600000, comments: 34700, time: "24 de janeiro de 2025", description: "Seja forte e corajoso, Brasil.", imageBlur: 8, avatarBlur: 2 },
  { username: "Re*****", avatar: avChat3, postImage: postagemCariani, likes: 93000, comments: 758, time: "27 de janeiro de 2025", description: "Video hoje às 18hs sobre toda movimentação que está acontecendo na @growthsupplements ….", imageBlur: 8, avatarBlur: 2 },
  { username: "Me*****", avatar: av7, postImage: av2, likes: 156, comments: 3, time: "12 de janeiro de 2025" },
  { username: "Pe*****", avatar: av3, postImage: av11, likes: 67, comments: 2, time: "3 de janeiro de 2025" },
  { username: "Th*****", avatar: av9, postImage: av4, likes: 421, comments: 12, time: "28 de dezembro de 2024" },
  { username: "La*****", avatar: av4, postImage: av10, likes: 178, comments: 6, time: "21 de dezembro de 2024" },
  { username: "En*****", avatar: av1, postImage: av6, likes: 95, comments: 1, time: "14 de dezembro de 2024" },
  { username: "Be*****", avatar: av8, postImage: av3, likes: 543, comments: 14, time: "5 de dezembro de 2024" },
  { username: "So*****", avatar: av2, postImage: av9, likes: 267, comments: 7, time: "27 de novembro de 2024" },
  { username: "Le*****", avatar: av5, postImage: av1, likes: 134, comments: 4, time: "18 de novembro de 2024" },
  { username: "Ma*****", avatar: av6, postImage: av12, likes: 389, comments: 9, time: "9 de novembro de 2024" },
  { username: "Ga*****", avatar: av10, postImage: av7, likes: 72, comments: 2, time: "31 de outubro de 2024" },
  { username: "Is*****", avatar: av11, postImage: avChat1, likes: 451, comments: 11, time: "14 de outubro de 2024" },
  { username: "Ra*****", avatar: av12, postImage: avChat2, likes: 213, comments: 5, time: "2 de outubro de 2024" },
];

// Função auxiliar para formatar timestamp em data
function formatPostDate(timestamp) {
  if (!timestamp) return 'Hoje';
  
  const date = new Date(timestamp * 1000);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
  
  if (diffDays === 0) return 'Hoje';
  if (diffDays === 1) return 'Ontem';
  if (diffDays < 7) return `${diffDays} dias atrás`;
  
  return date.toLocaleDateString('pt-BR', { day: 'numeric', month: 'long', year: 'numeric' });
}

// Mascara username (ex: "cristiano" -> "cri*****")
function maskUsername(username) {
  if (!username || username.length <= 3) return username;
  return username.substring(0, 3) + '*****';
}

export default function Feed() {
  const { t } = useTranslation();
  const [city, setCity] = useState("");
  const [posts, setPosts] = useState(MOCK_POSTS);
  const [isLoadingPosts, setIsLoadingPosts] = useState(true);

  // Buscar localização
  useEffect(() => {
    const controller = new AbortController();
    async function fetchLocation() {
      try {
        const res = await fetch("https://wtfismyip.com/json", {
          signal: controller.signal,
        });
        const data = await res.json();
        if (data?.YourFuckingLocation) {
          const parts = data.YourFuckingLocation.split(",");
          setCity((parts[0] || "").trim());
        }
      } catch {}
    }
    fetchLocation();
    return () => controller.abort();
  }, []);

  // Buscar posts reais dos seguidores para o feed
  useEffect(() => {
    async function fetchRealPosts() {
      try {
        // Pegar o username da busca atual
        const currentUsername = localStorage.getItem('current_username');
        if (!currentUsername) {
          console.log('ℹ️ Nenhum username em localStorage, usando posts mockados');
          setIsLoadingPosts(false);
          return;
        }

        console.log('🔍 Buscando seguidores de:', currentUsername);

        const result = await fetchProfileCached(currentUsername);
        const { success, data } = result || {};
        
        if (success && data && data.followers && data.followers.length > 0) {
          const followers = data.followers;
          console.log('✅ Seguidores encontrados:', followers.length);

          // OTIMIZAÇÃO: Usar os posts que JÁ VIERAM na primeira requisição
          // A API já retorna posts do usuário principal, vamos usar esses
          const existingPosts = data.posts || [];
          console.log(`✅ ${existingPosts.length} posts já disponíveis da primeira requisição`);
          
          // Embaralhar seguidores uma única vez para usar em tudo
          const shuffledFollowers = [...followers].sort(() => Math.random() - 0.5);
          
          // Se temos posts do usuário principal, vamos usá-los
          let realPosts = [];
          
          if (existingPosts.length > 0) {
            // Transformar os posts existentes no formato do Feed
            realPosts = existingPosts.slice(0, 3).map(post => {
              const imageUrl = post.post.image_url;
              const isValidImage = imageUrl && !imageUrl.endsWith('url=') && !imageUrl.includes('url=undefined');
              
              return {
                username: maskUsername(post.de_usuario.username),
                avatar: post.de_usuario.profile_pic_url,
                postImage: isValidImage ? imageUrl : `https://picsum.photos/id/${Math.floor(Math.random() * 500) + 1}/600/600`,
                likes: post.post.like_count,
                comments: post.post.comment_count,
                time: formatPostDate(post.post.timestamp),
                description: post.post.caption || '✨',
                imageBlur: 0, // SEM blur
                avatarBlur: 0,
                isRealPost: true
              };
            });
            
            console.log(`✅ ${realPosts.length} posts reais transformados para o feed`);
          } else {
            // Se não temos posts, criar alguns com seguidores aleatórios
            console.log('⚠️ Nenhum post disponível, usando fallback com seguidores');
            const followersForPosts = shuffledFollowers.slice(0, 3);
            
            realPosts = followersForPosts.map(follower => {
              const picId = Math.floor(Math.random() * 500) + 1;
              return {
                username: maskUsername(follower.username),
                avatar: follower.profile_pic_url,
                postImage: `https://picsum.photos/id/${picId}/600/600`,
                likes: Math.floor(Math.random() * 5000) + 500,
                comments: Math.floor(Math.random() * 100) + 10,
                time: 'Hoje',
                description: '✨',
                imageBlur: 0,
                avatarBlur: 0,
                isRealPost: true
              };
            });
          }

          // Criar 4 posts restritos com outros seguidores
          const followersForRestricted = shuffledFollowers.slice(3, 7);
          const restrictedPosts = followersForRestricted.map((follower) => ({
            username: maskUsername(follower.username),
            avatar: follower.profile_pic_url,
            postImage: follower.profile_pic_url,
            likes: Math.floor(Math.random() * 500) + 50,
            comments: Math.floor(Math.random() * 20) + 1,
            time: 'Hoje',
            imageBlur: 30,
            avatarBlur: 5,
            isRestricted: true
          }));

          // Total: 7 posts (3 de seguidores + 4 restritos)
          setPosts([...realPosts, ...restrictedPosts]);
        } else {
          console.log('⚠️ Nenhum seguidor encontrado, usando mockados');
          setPosts(MOCK_POSTS);
        }
      } catch (error) {
        console.error('❌ Erro ao buscar posts:', error);
        setPosts(MOCK_POSTS);
      } finally {
        setIsLoadingPosts(false);
      }
    }

    fetchRealPosts();
  }, []);

  return (
    <div className="feed-page">
      <FeedHeader />

      <main className="feed-content">
        <StoriesBar />
        
        {isLoadingPosts && (
          <div style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
            {t('feed.loadingPosts')}
          </div>
        )}
        
        {posts.map((post, index) => (
          <FeedPost
            key={index}
            username={post.username}
            avatar={post.avatar}
            likes={post.likes}
            comments={post.comments}
            time={post.time}
            blurLevel={index}
            location={index === 0 && city ? city : post.location}
            description={post.description}
            postImage={post.postImage}
            imageBlur={post.imageBlur}
            avatarBlur={post.avatarBlur}
          />
        ))}
      </main>

      <TrialBanner />
      <BottomNav />
    </div>
  );
}